import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import nl from './locales/nl/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'nl',
    supportedLngs: ['nl', 'en'],
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: { translation: en },
      nl: { translation: nl },
    },
    detection: {
      // Order of detection methods
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      // Cache the language in localStorage
      caches: ['localStorage'],
      // Query parameter name for direct linking (e.g., ?lang=en)
      lookupQuerystring: 'lang',
      // localStorage key
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;